export default __webpack_public_path__ + "static/media/solarimg.456c9ca0.png";